module.exports = __webpack_public_path__ + "static/media/logo1.75eaf60a.jpg";